import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

interface MaintenanceResponse {
  maintenance: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard  {
  private readonly MAINTENANCE_BYPASS_PASSWORD = 'cdd-maintenance-bypass-2026';
  private readonly MAINTENANCE_BYPASS_KEY = 'maintenance-bypass';
  private readonly MAINTENANCE_ENDPOINT = `${environment.url}/api/Auth/maintenance`;

  constructor(private router: Router, private http: HttpClient) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const bypass = localStorage.getItem(this.MAINTENANCE_BYPASS_KEY);
    if (bypass === this.MAINTENANCE_BYPASS_PASSWORD) {
      return of(true);
    }

    return this.http.get<MaintenanceResponse>(this.MAINTENANCE_ENDPOINT).pipe(
      map((response: MaintenanceResponse) => {
        if (response.maintenance) {
          if (state.url !== '/maintenance') {
            this.router.navigateByUrl('/maintenance');
            return false;
          }
          return true;
        }
        return true;
      }),
      catchError(() => {
        return of(true);
      })
    );
  }
}
